var _style, _ellipse, _polyline, _line, _line2, _line3, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOscillatoryLamp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "13.3px",
    viewBox: "0 0 16 13.3",
    style: {
      enableBackground: "new 0 0 16 13.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oscillatory Lamp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 8,
    cy: 8.6,
    rx: 4.4,
    ry: 4.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "4.9,5.5 8,8.6 11.1,11.8 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 4.9,
    y1: 11.8,
    x2: 11.1,
    y2: 5.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 3.6,
    y1: 8.6,
    x2: 0,
    y2: 8.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.4,
    y1: 8.6,
    x2: 16,
    y2: 8.6
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "5.5,2.8 6.9,2.8 6.9,0.1 9.1,0.1 9.1,2.8 10.5,2.8 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOscillatoryLamp);
export default __webpack_public_path__ + "static/media/OscillatoryLamp.cfbd55a369490a6962c4e4e8237fd60f.svg";
export { ForwardRef as ReactComponent };